import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';
import ReportsPageFeature from '../../features/report-feature/ReportsPageFeature';

const ReportsApp = () => {
  return (
    <Fragment>
      <Route exact path="/reports" component={ReportsPageFeature} />
    </Fragment>
  );
};

export default ReportsApp;
